import React, { useState, useEffect } from "react";
import styles from "./Audio.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeUp, faPause } from "@fortawesome/free-solid-svg-icons";
import LessonInstruction from "../../containers/instruction/LessonInstruction";
import useAudioPlayback from "../../hooks/useAudioPlayback";
import { t } from "../../lib/i18n";

const Audio = ({ data, audioUrl, blockData }) => {

  const { state, togglePlayback} = useAudioPlayback(audioUrl, "audio");

  const hasModel = () => {
    let instructionCount = 0;
    for (let i = 0; i < blockData.content.length; i++) {
      if (blockData.content[i].type === "instruction") instructionCount += 1;
    }
    return instructionCount >= 2;
  };

  const handlePlayPause = () => {
    togglePlayback();
  };

  return (
    <div className={styles.default_card + " default-card default-card-full-width"}>
      {data.type === "instruction" ? (
        <LessonInstruction instructionText={data.instruction} audioUrl={audioUrl} />
      ) : (
        <>
          <div className={styles.audio_template_instruction_container}>
            <h3>{t("Listen to the Audio.")}</h3>
          </div>
          <div className={styles.audio_template_title_container + " title-container"}>
            <div className={styles.audio_container} onClick={handlePlayPause}>
              <div className={styles.audio_icon_container}>
                {state === 'playing' ? (
                  <FontAwesomeIcon className={styles.audio_icon} size={"2x"} icon={faPause} />
                ) : (
                  <FontAwesomeIcon className={styles.audio_icon} size={"2x"} icon={faVolumeUp} />
                )}
              </div>
            </div>
          </div>
          {hasModel() && blockData.complement && blockData.complement.type !== "practice" && (
            <div className={styles.fluency_model + " title-container"}>
              <h3 className="instruction-title">{t("Model")}</h3>
              <h5 className="instruction-text">{blockData.content.en}</h5>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Audio;